define([
	"csi",
	"csi/comm/PostRequest",
	"csi/access/crews"
], function(csi,PostRequest,crews) {

	var	exportBatchesByType = null;

	return {
		isCurrentUserAllowedToExport: function() {
			//TODO: move it to AccessControl.js when it supports global/type-specific actions
			return crews.isInGlobalRoles(['Export Administrator']);
		},

		getManuallyTriggeredBatchesForType: function(/*String*/nodeType,/*Cache*/cache) {
			// summary: can the node type be exported manually.
			// It asks the server for this information.

			if (exportBatchesByType == null) {
				var request = new PostRequest("Export","GetAllManuallyTriggeredBatches");

				var batchesByType = {};
				var types;
				request.post({
					sync: true,
					load: function(response) {
						cache.cacheResponse(response);

						var node = response.getResultNode();
						types = node.Types;
						var batches = node.Batches;
						console.assert(types.length==batches.length,"The length of 'Types' and 'Batches' attributes must be the same");

						// put batches into a hash object with keys equal to node type
						for (var i=0; i < types.length; i++) {
							var type = types[i];
							var batch = cache.getNode(batches[i]);
							if (batchesByType[type])
								batchesByType[type].push(batch);
							else
								batchesByType[type] = [batch];
						}

						// now sort by name
						csi.applyForEach(batchesByType,function(batches){
							batches.sort(function(batch1,batch2){
								return batch1.$Name.localeCompare(batch2.$Name);
							});
						});
					},
					error: function(err) {
						console.warn("Cannot get Export Batches from the server");
					}
				});

				exportBatchesByType = batchesByType;
			}
			return exportBatchesByType[nodeType];
		}
	};
});